// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "patientDashboard." + chunkId + "." + {"432":"441d7b3e9eeb0ed409ae","979":"d8782ef159cfd2df643c"}[chunkId] + ".js";
};